define('lq/webPushNotifications',[
    'underscore',
    'lq/main',
    'lq/dispatcher'
], function(_, main, dispatcher) {
    'use strict';

    var currentTokenKey = 'notifications.firebase_token';
    var currentRegistrationUserIdKey = 'notifications.user_id';
    var notifications = undefined;
    var messaging;

    // note: BroadcastChannel doesn't exist in Safari, but at the moment we don't support Safari anyway
    if (main.areWebNotificationsEnabled()) {
        // Your web app's Firebase configuration
        var firebaseConfig = {
            apiKey: main.getFirebaseApiKey(),
            projectId: main.getFirebaseProjectId(),
            messagingSenderId: main.getFirebaseSenderId(),
            appId: main.getFirebaseAppId()
        };

        navigator.serviceWorker.controller.postMessage({
            type: 'FIREBASE_CONFIG',
            config: firebaseConfig,
            icon: main.getNotificationIcon(),
            url: main.getNotificationsEntryPage()
        });

        // Initialize Firebase
        firebase.initializeApp(firebaseConfig);

        // Initialize Firebase on service worker with `firebaseConfig`. This is REQUIRED for Firebase to work.
        // I would use async/await but it is probably too much for the browsers clients are using.
        navigator.serviceWorker.getRegistration().then(function (registration) {
            firebase.messaging().useServiceWorker(registration);
            messaging = firebase.messaging();
        });
    }

    return {

        get: function (userId) {
            if (!messaging) return null; // I can't think of even one scenario where this would be used. getRegistration() should be pretty much instant.
            if (!notifications) {
                var listeners = [];
                var receivedNotifications = [];
                var notificationsBroadcast = new BroadcastChannel('notifications');
                
                notificationsBroadcast.onmessage = function (e) {
                    var message = e.data;

                    receivedNotifications.push(message);

                    _.each(listeners, function (listener) {
                        listener(message);
                    });
                }
                
                // Get registration token. Initially this makes a network call, once retrieved
                // subsequent calls to getToken will return from cache.
                messaging.getToken({ vapidKey: main.getFirebaseWPCert() }).then(function(newToken) {
                    if (newToken) {
                        var currentToken = localStorage.getItem(currentTokenKey);
                        var registeredUserId = localStorage.getItem(currentRegistrationUserIdKey);

                        if (currentToken !== newToken || registeredUserId !== userId) {
                            dispatcher.dispatch('LicquidAction/RegisterMobileDevice',
                                {
                                    deviceId: newToken,
                                    previousDeviceId: currentToken,
                                    messenger: "fcm",
                                    platform: "web"
                                })
                                .done(function () {
                                    localStorage.setItem(currentTokenKey, newToken)
                                    localStorage.setItem(currentRegistrationUserIdKey, userId);
                                }, $.noop);
                        }
                    } else {
                        // Show permission request UI
                    }
                }).catch(function(err) {
                });

                // Handle incoming messages. Called when:
                // - a message is received while the app has focus
                // - the user clicks on an app notification created by a service worker
                //   `messaging.onBackgroundMessage` handler.
                messaging.onMessage(function(payload) {
                    var message = payload.data;

                    message.foreground = true;

                    receivedNotifications.push(message);

                    _.each(listeners, function (listener) {
                        listener(message);
                    });
                });

                notifications = {

                    hasReceivedNotifications: function () {
                        return receivedNotifications.length > 0;
                    },

                    getAllReceivedNotifications: function () {
                        return receivedNotifications;
                    },

                    addListener: function (callback) {
                        listeners.push(callback);
                    }

                };

            }

            return notifications;
        }

    }
});
